import Filters from '@/filters'

export const pathInRoutes = function (routes, pathToFind) {
  return routes.map(({ name }) => name).includes(pathToFind);
};

export const guestRoutes = function (routes) {
  return routes.filter(route => route.meta && route.meta.guest);
};

export const debounce = function (callback, wait) {
  let timeout;

  return function (...args) {
    const functionCall = () => callback.apply(this, args);

    clearTimeout(timeout);

    timeout = setTimeout(functionCall, wait);
  };
};

export const localStoreItems = function () {
  return ['__access_token', '__user_id', '__token_expiry'];
};

export const isIframeApp = function () {
  return process.env.VUE_APP_APP_MODE && process.env.VUE_APP_APP_MODE === 'iframe';
}

export const hasRecaptchaKey = function () {
  return process.env.VUE_APP_RECAPTCHA_ENABLED === 'true' && !!process.env.VUE_APP_RECAPTCHA_SITE_KEY;
}


export const computeDiscountAmount = function (cost, promoCode, ticketType) {
  const { reward_amount, reward_kind } = promoCode.promo_code_benefit;
  switch (reward_kind) {
    case "flat_rate_discount_on_trips":
      promoCode.discountText = reward_amount
        ? `Promo of ${Filters.currency(
            reward_amount
          )} Off Applied${ticketType.toLowerCase() === 'return'? ' to Outbound Trip' : ''}`
        : null;
      promoCode.discountAmount = reward_amount ? reward_amount : 0;
      return promoCode;
    case "percentage_discount_on_trips":
      promoCode.discountAmount =
        cost && reward_amount ? (reward_amount / 100) * cost : 0;
      promoCode.discountText =
        cost && reward_amount
          ? `Promo of ${reward_amount}% Off Applied${ticketType.toLowerCase() === 'return'? ' to Outbound Trip' : ''}`
          : null;
      return promoCode;
    default:
      promoCode.discountAmount = 0;
      promoCode.discountText = null;
      return promoCode;
  }
}

/**
 * --------------- Money format Utils ---------------
 */
export const NAIRA = '₦';
export const NAIRA_UNICODE = '\u20A6';

function formatNumberToMoney(
  number = 0,
  decimals = 0,
  { countryCode = 'NG', currencyCode } = {}
) {
  const formatter = new Intl.NumberFormat(`en-${countryCode}`, {
    style: currencyCode && 'currency',
    currency: currencyCode,
    minimumFractionDigits: decimals
  });
  return formatter.format(number ? Number(+number).toFixed(decimals || 2) : 0);
}

export function convertCurrencyFormatToNumbers(currencyText) {
  if (currencyText && typeof currencyText === 'string') {
    return parseFloat(currencyText.replace(/[\u20A6₦,]/gi, ''));
  }
}

export function formatNumberAsCurrencyText(number) {
  return `${NAIRA}${formatNumberToMoney(number)}`;
}

export async function copyText(text, toastService) {
  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
    } else {
      const el = document.createElement('input');
      el.value = text;
      el.style.opacity = 0;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
    toastService.success('Copied!','', {timeOut: 500});
  } catch (e) {
    toastService.error('Oops! unable to copy');
    console.error(e);
  }
}

export const extractErrorMessage = (error, defaultMessage = null) => {
  return error.response && error.response.data && error.response.data.message
    ? error.response.data.message
    : defaultMessage || error.toString()
}
